import React from 'react';
import { Card, Row, Col, Typography, Space, Flex } from 'antd';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PageLayout from '../../components/PageLayout';
import './ContactPage.css';

const { Title, Text } = Typography;

const ContactPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageLayout className="contact-page">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Flex justify="center">
          <Title level={2} className="contact-title">
            {t('contact.title')}
          </Title>
        </Flex>

        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} sm={24} md={20} lg={16} xl={12}>
            <Card className="contact-card">
              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                {/* Phone Number */}
                <Flex align="start" gap="middle" className="contact-item">
                  <div className="contact-icon-wrapper">
                    <PhoneOutlined className="contact-icon" />
                  </div>
                  <Space direction="vertical" size="small" style={{ flex: 1 }}>
                    <Text strong className="contact-label">
                      {t('contact.phone')}
                    </Text>
                    <Text className="contact-value">
                      {t('contact.phoneNumber')}
                    </Text>
                  </Space>
                </Flex>

                {/* Email */}
                <Flex align="start" gap="middle" className="contact-item">
                  <div className="contact-icon-wrapper">
                    <MailOutlined className="contact-icon" />
                  </div>
                  <Space direction="vertical" size="small" style={{ flex: 1 }}>
                    <Text strong className="contact-label">
                      {t('contact.email')}
                    </Text>
                    <Text className="contact-value">
                      {t('contact.emailAddress')}
                    </Text>
                  </Space>
                </Flex>

                {/* Address */}
                <Flex align="start" gap="middle" className="contact-item">
                  <div className="contact-icon-wrapper">
                    <EnvironmentOutlined className="contact-icon" />
                  </div>
                  <Space direction="vertical" size="small" style={{ flex: 1 }}>
                    <Text strong className="contact-label">
                      {t('contact.address')}
                    </Text>
                    <Text className="contact-value">
                      {t('contact.addressValue')}
                    </Text>
                  </Space>
                </Flex>
              </Space>
            </Card>
          </Col>
        </Row>
      </Space>
    </PageLayout>
  );
};

export default ContactPage;

